module.exports = __webpack_public_path__ + "static/media/installation-video-ios-DA.dde53c79.mp4";